import { render, staticRenderFns } from "./ComicSelector.vue?vue&type=template&id=627bb5ec&scoped=true&"
import script from "./ComicSelector.vue?vue&type=script&lang=js&"
export * from "./ComicSelector.vue?vue&type=script&lang=js&"
import style0 from "./ComicSelector.vue?vue&type=style&index=0&id=627bb5ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627bb5ec",
  null
  
)

export default component.exports